<template>
  <div>
    <div v-if="form == 'test-attachments'">
      <TestAttachmentForm :form="form"></TestAttachmentForm>
    </div>

    <div v-if="form == 'bin-repair'">
      <BinRepairForm :form="form"></BinRepairForm>
    </div>
    <div v-if="form == 'bin-new'">
      <NewBinForm :form="form"></NewBinForm>
    </div>
    <div v-if="form == 'bin-new2'">
      <NewBinForm2 :form="form"></NewBinForm2>
    </div>
    <div v-if="form == 'bin-new-caddy'">
      <NewBinCaddyForm :form="form"></NewBinCaddyForm>
    </div>

    <div v-if="form == 'insurance'">
      <InsuranceForm :form="form"></InsuranceForm>
    </div>

    <div v-if="form == 'events'">
      <EventsForm :form="form"></EventsForm>
    </div>
    <div v-if="form == 'events-food-safety'">
      <FoodSafetyNotification :form="form"></FoodSafetyNotification>
    </div>

    <div v-if="form == 'third-party-road-reserve-permit'">
      <ThirdPartyRoadReservePermitForm :form="form"></ThirdPartyRoadReservePermitForm>
    </div>

    <div v-if="form == 'building-inspection'">
      <BuildingInspectionNotification :form="form"></BuildingInspectionNotification>
    </div>

    <div v-if="form == 'elected-members-attendance'">
      <ElectedMembersAttendanceForm :form="form"></ElectedMembersAttendanceForm>
    </div>

    <div v-if="form == 'freedom-of-information'">
      <FreedomOfInformationForm :form="form"></FreedomOfInformationForm>
    </div>

    <div v-if="form == 'food-business'">
      <FoodBusiness :form="form"></FoodBusiness>
    </div>

    <div v-if="form == 'book-club'">
      <BookClub :form="form"></BookClub>
    </div>


    <!--         <div v-if="form == 'wards'">
            <WardsForm :form='form'></WardsForm>
        </div>
    -->
  </div>
</template>

<script>
  var Vue = require("vue");

//import VeeValidate from 'vee-validate';
import Vuelidate from "vuelidate";

import TestAttachmentForm from "./testAttachments";

import BinRepairForm from "./LayoutBinRepair";
import NewBinForm from "./LayoutBinNew";
import NewBinForm2 from "./LayoutBinNew2";
import NewBinCaddyForm from "./LayoutBinNewCaddy";
import InsuranceForm from "./LayoutInsurance";
import EventsForm from "./LayoutEventsReservesRoads";
import FoodSafetyNotification from "./LayoutFoodSafetyNotification";
import ThirdPartyRoadReservePermitForm from "./LayoutThirdPartyRoadReservePermit";
import BuildingInspectionNotification from "./LayoutBuildingInspections";
import ElectedMembersAttendanceForm from "./LayoutElectedMembersAttendance";
import FreedomOfInformationForm from "./LayoutFreedomOfInformation";
import FoodBusiness from "./LayoutFoodBusinessNotification";
import BookClub from "./LayoutBookClub";

// import WardsForm from './LayoutWards';

//Vue.use(VeeValidate);
Vue.use(Vuelidate);

export default {
    components: {
        TestAttachmentForm,
        BinRepairForm,
        NewBinForm,
        NewBinForm2,
        NewBinCaddyForm,
        EventsForm,
        FoodSafetyNotification,
        InsuranceForm,
        ThirdPartyRoadReservePermitForm,
        BuildingInspectionNotification,
        ElectedMembersAttendanceForm,
        FreedomOfInformationForm,
        FoodBusiness,
        BookClub
        // ,WardsForm
    },

    data() {
        return {};
    },
    props: {
        form: {}
    }
};
</script>


// WEBPACK FOOTER //
// Modules/OnlineForm/Resources/assets/js/components/Forms.vue